export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Universally Connected",
  headline: "Use our mobile app",
  description:
    "you don't have to carry around your laptop in order to get your balance info, you can simply download our user-friendly smartphone app.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-3.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};
export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Privacy Matters",
  headline: "Highly Secure and Flexible",
  description:
    "Vir-Bank keeps yoour privacy at heart, with our 2-step confirmation you'll feel more secure aboutb your purchases and cridet-card data.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../../images/svg-2.svg").default,
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
};
export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Our Team Will Help",
  headline: "We're Always Growing",
  description:
    "in Vir-Bank client comes first, even when travelling abroad our team is up for your service 24/7.",
  buttonLabel: "Sign Up",
  imgStart: false,
  img: require("../../images/svg-5.svg").default,
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
};
